/**
 * @param {入口配置}
 */ 
import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import utils from './utils/utils';
import http from './utils/http';
import store from './store/store'; 
	import ElementUI from 'element-ui';
// import jsEncrypt from 'jsencrypt'
// import VueCookies from 'vue-cookies'
 
 import MyNavbar from './components/Navbar.vue';
 import MyPagination from './components/Pagination.vue';  
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';  
Vue.use(MintUI);
Vue.use(utils);
Vue.use(http); 
Vue.use(ElementUI); 
Vue.component('MyNavbar',MyNavbar);
Vue.component('MyPagination',MyPagination);    
 // 导入 crypto-js 包 
import cryptoJS from 'crypto-js/crypto-js'
//把AES加密vue原型里
Vue.prototype.$cryptoJS = cryptoJS;
// Vue.use(VueCookies);
import './assets/css/index.less';  

new Vue({
    el: '#app',
    router,
     store,
    components: {
        App
    },
    template: '<App/>'
})
